// removed by extract-text-webpack-plugin
module.exports = {"redFlagColor":"#E41F6D","yellowFlagColor":"#F7AC38","greenFlagColor":"#3EA046","allFlagColor":"#40403F","chartMaxColor":"#ff0364","chartMinColor":"#219EBC","chartMaxColorEcg":"#055780","chartMinColorEcg":"#219EBC"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/print.scss
// module id = iLNi
// module chunks = 2